import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import { RawIntlProvider } from 'react-intl';
import { getLanguage } from "../utils/intlUtility";
import intl from "../intl";
import { transformLocale } from "../utils/commonUtility";
import dayjs from "../dayjs-config";
import LocalizationContext, { defaultLocalizationContext } from "./LocalizationContext";

var loadDayjsLocale = function loadDayjsLocale(locale) {
  return _regeneratorRuntime.async(function loadDayjsLocale$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _regeneratorRuntime.awrap(import("dayjs/locale/".concat(locale, ".js")));

        case 2:
        case "end":
          return _context.stop();
      }
    }
  });
};

var LocalizationProvider = function LocalizationProvider(_ref) {
  var language = _ref.language,
      children = _ref.children,
      onError = _ref.onError,
      onLoad = _ref.onLoad,
      shouldSkipLoadWait = _ref.shouldSkipLoadWait,
      translations = _ref.translations,
      _ref$debug = _ref.debug,
      debug = _ref$debug === void 0 ? false : _ref$debug,
      preferences = _ref.preferences;

  var _useState = useState(function () {
    return intl.getIntl();
  }),
      _useState2 = _slicedToArray(_useState, 2),
      intlValue = _useState2[0],
      setIntl = _useState2[1];

  var _useState3 = useState(!shouldSkipLoadWait),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  useEffect(function () {
    var initLocalization = function initLocalization() {
      var userLanguage, dayJslocale;
      return _regeneratorRuntime.async(function initLocalization$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              userLanguage = language || getLanguage();
              dayJslocale = transformLocale(userLanguage);
              _context2.prev = 2;
              _context2.next = 5;
              return _regeneratorRuntime.awrap(intl.init({
                language: userLanguage,
                onError: onError,
                onLoad: onLoad,
                translations: translations,
                debug: debug
              }));

            case 5:
              _context2.next = 7;
              return _regeneratorRuntime.awrap(loadDayjsLocale(dayJslocale));

            case 7:
              setIntl(intl.getIntl());
              dayjs.locale(dayJslocale);
              setLoading(false);

              if (debug) {
                console.log('[Localize] User language:', userLanguage);
                console.log('[Localize] Setting dayjs locale to', dayJslocale);
              }

              _context2.next = 17;
              break;

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](2);
              console.error('Error initializing localization:', _context2.t0);
              setLoading(false);

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, null, null, [[2, 13]]);
    };

    initLocalization();
  }, [language]);

  if (loading) {
    return null;
  } // @ts-ignore


  return React.createElement(RawIntlProvider, {
    value: intlValue,
    "data-qa": "localization-provider"
  }, React.createElement(LocalizationContext.Provider, {
    value: _extends({}, defaultLocalizationContext, {
      preferences: preferences !== null && preferences !== void 0 ? preferences : defaultLocalizationContext.preferences
    })
  }, children));
};

export default LocalizationProvider;